import * as actionTypes from '../actions/actionTypes';

const initialState = {
    rowData: null
}

const actionReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_ACTION_DETAIL:
         
            return {
                ...state,
                rowData: action.rowData

            }
        
        default:
            return state;

    }
}

export default actionReducer;